import { RepeatMealOnDaysRequest } from "@/clients/models/RepeatMealOnDaysRequest";
import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useRepeatMealOnSlots = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.PLAN_REPEAT_MEAL],
    mutationFn: async (requestBody: RepeatMealOnDaysRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await PlansService.repeatMealOnSlotsApiV1PlansMealsRepeatPost(
        user.id,
        requestBody,
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.PLAN] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CALORIE_BUDGET] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.SHOPPING_LIST] });
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.includes(QueryKeys.BALANCE_CALORIES) ||
          query.queryKey.includes(QueryKeys.BALANCE_PROTEIN),
      });
    },
  });

  return {
    repeatMealOnSlots: mutate,
    repeatMealOnSlotsAsync: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
